import qipanzhou from "./index.vue";
import qipanzhouHome from "./Home.vue";

const anchorRoom = () => import("./anchorRoom.vue");
const steelBoxDehumidifier = () => import("./steelBoxDehumidifier.vue");
const steelBoxFan = () => import("./steelBoxFan.vue");
const steelBoxSideSpan = ()=>import('./steelBoxSideSpan.vue')
const gasClamp = ()=> import('./gasClamp.vue')
const mainCable = ()=>import('./mainCable.vue')
const saddleRoom = ()=>import('./saddleRoom.vue')

const dataHistory = () => import('./../../components/DataHistory.vue')
const bridgeImg = () => import('./bridgeImg.vue')
const login = () => import("./login.vue");
const emptyComponent = () => import("./emptyRouterComponent.vue");

export default [
  {
    path: "/qipanzhouIndex",
    name: "qipanzhouIndex",
    component: qipanzhouHome,
  },
  {
    path: "/qipanzhou/login",
    name: "qipanzhouLogin",
    component: login,
  },
  {
    path: "/qipanzhou",
    name: "qipanzhou",
    redirect: "/qipanzhou/anchorRoom",
    component: qipanzhou,
    children: [
      {
        path: "anchorRoom",
        name: "anchorRoom",
        redirect: "/qipanzhou/anchorRoom/huangshiWest",
        component: emptyComponent,
        children: [
          {
            path: "huangshiWest",
            name: "anchorRoomHuangshiWest",
            component: anchorRoom,
          },
          {
            path: "huangshiEast",
            name: "anchorRoomhuangshiEast",
            component: anchorRoom,
          },
          {
            path: "huanggangWest",
            name: "anchorRoomhuanggangWest",
            component: anchorRoom,
          },
          {
            path: "huanggangEast",
            name: "anchorRoomhuanggangEast",
            component: anchorRoom,
          },
        ],
      },
      {
        path: "steelBoxDehumidifier",
        name: "steelBoxDehumidifier",
        redirect: "/qipanzhou/steelBoxDehumidifier/huangshi",
        component: emptyComponent,
        children: [
          {
            path: "huangshi",
            name: "steelBoxDehumidifierHuangshi",
            component: steelBoxDehumidifier,
          },
          {
            path: "huanggang",
            name: "steelBoxDehumidifierHuanggang",
            component: steelBoxDehumidifier,
          },
        ],
      },
      {
        path: "steelBoxFan",
        name: "steelBoxFan",
        redirect: "/qipanzhou/steelBoxFan/huangshi",
        component: emptyComponent,
        children: [
          {
            path: "huangshi",
            name: "steelBoxFanHuangshi",
            component: steelBoxFan,
          },
          {
            path: "huanggang",
            name: "steelBoxFanHuanggang",
            component: steelBoxFan,
          },
        ],
      },
      {
        path: "steelBoxSideSpan",
        name: "steelBoxSideSpan",
        redirect: "/qipanzhou/steelBoxSideSpan/upstream",
        component: emptyComponent,
        children: [
          {
            path: "upstream",
            name: "steelBoxSideSpanUpstream",
            component: steelBoxSideSpan,
          },
          {
            path: "downstream",
            name: "steelBoxSideSpanDownstream",
            component: steelBoxSideSpan,
          },
        ],
      },
      {
        path: "mainCable",
        name: "mainCable",
        redirect: "/qipanzhou/mainCable/huangshi",
        component: emptyComponent,
        children: [
          {
            path: "huangshi",
            name: "mainCableHuangshi",
            component: mainCable,
          },
          {
            path: "huanggang",
            name: "mainCableHuanggang",
            component: mainCable,
          },
        ],
      },
      {
        path: "gasClamp",
        name: "gasClamp",
        component: gasClamp,
      },
      {
        path: "saddleRoom",
        name: "saddleRoom",
        component: saddleRoom,
      },
      {
        path: "bridgeImg",
        name: "bridgeImg",
        component: bridgeImg,
      },
      {
        path: "dataHistory",
        name: "qipanzhou_dataHistory",
        component: dataHistory,
      },
    ],
  },
];
